import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "city" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Kota", -1)
const _hoisted_5 = { class: "grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-4" }
const _hoisted_6 = { class: "goin-top p-2" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "goin-bottom p-2" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = {
  key: 0,
  class: "text-center",
  style: {"font-size":"11px"}
}
const _hoisted_11 = {
  key: 1,
  class: "text-center",
  style: {"font-size":"11px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_CityForm = _resolveComponent("CityForm")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "h-full" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Kota",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              canClick: true,
              onSubmitInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData(_ctx.inputSearch))),
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (data) => {
            return (_openBlock(), _createBlock("div", {
              class: "",
              key: data.Id,
              onClick: ($event: any) => (_ctx.route.meta.permission.update ? _ctx.editData(data) : function(){})
            }, [
              _createVNode("div", {
                class: _ctx.route.meta.permission.update ? 'relative container-card cursor-pointer' : 'relative container-card'
              }, [
                _createVNode("span", {
                  class: "p-2 rounded-md",
                  style: [{'background-color':data.IsActive ? '#66BB6A' : '#C4C4C4'}, {"position":"absolute","top":"5px","right":"5px"}]
                }, null, 4),
                _createVNode("div", _hoisted_6, [
                  _createVNode("h3", _hoisted_7, _toDisplayString(data.Kode), 1)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("h6", _hoisted_9, _toDisplayString(data.Nama), 1),
                  (data.MsGroupKotaNama !== null)
                    ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(`(Grup Kota : ${data.MsGroupKotaNama})`), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString('(Grup Kota : -)'), 1))
                ])
              ], 2)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Paginator, {
          rows: _ctx.filters.pageSize,
          totalRecords: _ctx.totalRecords,
          onPage: _ctx.onPage
        }, null, 8, ["rows", "totalRecords", "onPage"])
      ]),
      _: 1
    }),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CityForm, {
          data: _ctx.dataForm,
          onCloseSidebarCity: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeSidebar())),
          onReloadData: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAllKotaSource()))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}